import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment as env} from '../../../environments/environment';
import {DateUtils} from '../../shared/date-utils';

@Injectable({
    providedIn: 'root'
})
export class ApPriceAlertsService {

    constructor(private http: HttpClient) {
    }

    public getApPriceAlerts(): Observable<ApPriceAlertModel[]> {
        return this.http.post<RoseApPriceAlertModel[]>(`${env.apiBaseUrl}/dashboard/ap_price_alerts`, {})
            .pipe(map(records => records.map(record => this.convertFromRose(record))));
    }

    // Dates become Date objects so the grid sorts them chronologically
    private convertFromRose(record: RoseApPriceAlertModel): ApPriceAlertModel {
        return {
            ...record,
            effStartDate: DateUtils.convertToDate(record.effStartDate),
            effEndDate: DateUtils.convertToDate(record.effEndDate)
        };
    }
}

export class ApPriceAlertModel {
    origin: string;
    destination: string;
    od: string;
    passengerClass: string;
    journeyType: string;
    apBucket: string;
    apFare: number;
    flexBucket: string;
    flexFare: number;
    fareDiff: number;
    effStartDate: Date;
    effEndDate: Date;
}

class RoseApPriceAlertModel {
    origin: string;
    destination: string;
    od: string;
    passengerClass: string;
    journeyType: string;
    apBucket: string;
    apFare: number;
    flexBucket: string;
    flexFare: number;
    fareDiff: number;
    effStartDate: string;
    effEndDate: string;
}
